import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import PaymentTermServices from '@Services/configurations/paymentTermServices';
import PaymentTermActions, { paymentTermActionTypes } from '@Actions/configurations/paymentTermActions';

/**
 *
 * @param {*} action
 */
function* _createPaymentTerm(action) {
  try {
    yield put(PaymentTermActions.createPaymentTermLoading(true));
    const { payload } = action;
    const newPaymentTerm = yield PaymentTermServices.createPaymentTerm(payload);
    if (newPaymentTerm.success) {
      yield put(TrackerActions.trackAction(paymentTermActionTypes.CREATE_PAYMENT_TERM.SUCCESS, newPaymentTerm));
      notification.open({
        type: 'success',
        message: 'New Payment Term created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: newPaymentTerm.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentTermActions.createPaymentTermLoading(false));
  } catch (error) {
    yield put(PaymentTermActions.createPaymentTermLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentTermActionTypes.CREATE_PAYMENT_TERM.ERROR, error));
  }
}

/**
 *
 */
function* createPaymentTerm() {
  yield takeLatest(paymentTermActionTypes.CREATE_PAYMENT_TERM.REQUEST, _createPaymentTerm);
}

/**
 *
 * @param {*} action
 */
function* _getPaymentTerms(action) {
  try {
    yield put(PaymentTermActions.getPaymentTermsLoading(true));
    const paymentTerms = yield PaymentTermServices.getPaymentTerms(action?.orgId, action?.page, action?.limit, action?.searchKeyword);
    yield put(PaymentTermActions.getPaymentTermsSuccess(paymentTerms));
    yield put(PaymentTermActions.getPaymentTermsLoading(false));
  } catch (error) {
    yield put(PaymentTermActions.getPaymentTermsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentTermActionTypes.GET_PAYMENT_TERMS.ERROR, error));
  }
}
/**
 *
 */
function* getPaymentTerms() {
  yield takeLatest(paymentTermActionTypes.GET_PAYMENT_TERMS.REQUEST, _getPaymentTerms);
}

/**
 *
 * @param {*} action
 */
function* _updatePaymentTerm(action) {
  try {
    yield put(PaymentTermActions.updatePaymentTermLoading(true));
    const updatedPaymentTerm = yield PaymentTermServices.updatePaymentTerm(action.payload);
    if (updatedPaymentTerm.success) {
      yield put(TrackerActions.trackAction(paymentTermActionTypes.UPDATE_PAYMENT_TERM.SUCCESS, updatedPaymentTerm.data));
      notification.open({
        type: 'success',
        message: 'Payment Term updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updatedPaymentTerm.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentTermActions.updatePaymentTermLoading(false));
  } catch (error) {
    yield put(PaymentTermActions.updatePaymentTermLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentTermActionTypes.UPDATE_PAYMENT_TERM.ERROR, error));
  }
}
/**
 *
 */
function* updatePaymentTerm() {
  yield takeLatest(paymentTermActionTypes.UPDATE_PAYMENT_TERM.REQUEST, _updatePaymentTerm);
}

/**
 * @param action
 */
function* _deletePaymentTerm(action) {
  try {
    yield put(PaymentTermActions.deletePaymentTermLoading(true));
    const paymentTerm = yield PaymentTermServices.deletePaymentTerm(action.payload);

    if (paymentTerm.success) {
      notification.open({
        type: 'success',
        message: 'Payment Term successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: paymentTerm.message,
        description: paymentTerm?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentTermActions.deletePaymentTermLoading(false));
  } catch (error) {
    yield put(PaymentTermActions.deletePaymentTermLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentTermActionTypes.DELETE_PAYMENT_TERM.ERROR, error));
  }
}

/**
 *
 */
function* deletePaymentTerm() {
  yield takeLatest(paymentTermActionTypes.DELETE_PAYMENT_TERM.REQUEST, _deletePaymentTerm);
}

/**
 *
 */
export default function* paymentTermSaga() {
  yield all([createPaymentTerm(), getPaymentTerms(), updatePaymentTerm(), deletePaymentTerm()]);
}
